import { render, staticRenderFns } from "./PayLockModal.vue?vue&type=template&id=5fcd2e1c&"
import script from "./PayLockModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PayLockModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports